import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import "./App.css";
import HomeLayout from "@/layouts/HomeLayout";
import ProtectedLayout from "@/layouts/ProtectedLayout/ProtectedLayout";

import RegisterPage from "@/pages/auth/RegisterPage";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import LoginPage from "@/pages/auth/LoginPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";

import ErrorPage from "@/pages/ErrorPage";
import ConfigurationPage from "@/pages/configuration/ConfigurationPage";
import PrivacyPolicyPage from "@/pages/configuration/PrivacyPolicyPage";
import TermsAndConditionsPage from "@/pages/configuration/TermsAndConditionsPage";
import EditorialGuidelinesPage from "@/pages/configuration/EditorialGuidelinesPage";
import FindADealEmailConfigPage from "@/pages/configuration/FindADealEmailConfigPage";
import CompareDefaultsConfigPage from "@/pages/configuration/CompareDefaultsConfigPage";

import UploadCar from "@/pages/manage-data/UploadCarForm/UploadCar";

import OfferLayout from "@/layouts/OfferLayout";
import OffersPage from "@/pages/manage-offers/ManageOffersPage";
import UploadOffer from "@/pages/manage-offers/UploadOfferForm/UploadOffer";
import ManageDataPage from "@/pages/manage-data/ManageDataPage";
import DashboardPage from "@/pages/dashboard/DashboardPage";
import MediaLibraryPage from "@/pages/media-library/MediaLibraryPage";
import UploadMediaPage from "@/pages/media-library/UploadMediaPage";
import AdvertisementPage from "@/pages/advertisement/AdvertisementPage";
import CreateAdvertisementPage from "@/pages/advertisement/CreateAdvertisementPage";
import ViewAdvertisementPage from "@/pages/advertisement/ViewAdvertisementPage";
import ManageVehiclesPage from "@/pages/manage-vehicles/ManageVehiclesPage";
import UploadVehiclePage from "@/pages/manage-vehicles/UploadVehiclePage";
import PopularSearchPage from "./pages/popular-search/PopularSearchPage";
import CreatePopularSearchPage from "./pages/popular-search/CreatePopularSearchPage";
import ViewPopularSearchPage from "./pages/popular-search/ViewPopularSearchPage";
import FeaturePage from "@/pages/feature/FeaturePage";
import CreateFeaturePage from "@/pages/feature/CreateFeaturePage";
import ViewFeaturePage from "@/pages/feature/ViewFeaturePage";
import ViewFeatureArticlePage from "@/pages/feature-article/ViewFeatureArticlePage";
import CreateFeatureArticlePage from "@/pages/feature-article/CreateFeatureArticlePage";
import FeatureArticlePage from "@/pages/feature-article/FeatureArticlePage";
import HeroModelPage from "./pages/hero-model/HeroModelPage";
import CreateHeroModelPage from "./pages/hero-model/CreateHeroModelPage";
import ViewHeroModelPage from "./pages/hero-model/ViewHeroModelPage";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-conditions" element={<TermsAndConditionsPage />} />
      <Route
        path="/editorial-guidelines"
        element={<EditorialGuidelinesPage />}
      />

      <Route element={<HomeLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset/:token" element={<ResetPasswordPage />} />
      </Route>

      <Route path="/" element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="manage-data" element={<ManageDataPage />} />
        <Route path="upload" element={<UploadCar />} />
        <Route path="offers" element={<OfferLayout />}>
          <Route index element={<OffersPage />} />
          <Route path="upload" element={<UploadOffer />} />
        </Route>

        <Route path="vehicles" element={<OfferLayout />}>
          <Route index element={<ManageVehiclesPage />} />
          <Route path="upload" element={<UploadVehiclePage />} />
        </Route>

        <Route path="media-gallery" element={<OfferLayout />}>
          <Route index element={<MediaLibraryPage />} />
          <Route path="upload-media" element={<UploadMediaPage />} />
        </Route>

        <Route path="advertisement" element={<OfferLayout />}>
          <Route index element={<AdvertisementPage />} />
          <Route path="create" element={<CreateAdvertisementPage />} />
          <Route path="edit/:id" element={<ViewAdvertisementPage />} />
        </Route>

        <Route path="popular-search" element={<OfferLayout />}>
          <Route index element={<PopularSearchPage />} />
          <Route path="create" element={<CreatePopularSearchPage />} />
          <Route path="edit/:id" element={<ViewPopularSearchPage />} />
        </Route>

        <Route path="feature-model" element={<OfferLayout />}>
          <Route index element={<FeaturePage />} />
          <Route path="create" element={<CreateFeaturePage />} />
          <Route path="edit/:id" element={<ViewFeaturePage />} />
        </Route>

        <Route path="hero-model" element={<OfferLayout />}>
          <Route index element={<HeroModelPage />} />
          <Route path="create" element={<CreateHeroModelPage />} />
          <Route path="edit/:id" element={<ViewHeroModelPage />} />
        </Route>

        <Route path="feature-article" element={<OfferLayout />}>
          <Route index element={<FeatureArticlePage />} />
          <Route path="create" element={<CreateFeatureArticlePage />} />
          <Route path="edit/:id" element={<ViewFeatureArticlePage />} />
        </Route>

        <Route path="configuration" element={<ConfigurationPage />} />
        <Route
          path="find-a-deal-email-config"
          element={<FindADealEmailConfigPage />}
        />
        <Route
          path="compare-defaults-config"
          element={<CompareDefaultsConfigPage />}
        />
      </Route>

      <Route path="*" element={<ErrorPage />} />
    </>
  )
);
